import * as React from "react";
import { useState, useEffect } from "react";
import { useCanImpersonate, useSocialCoachSession } from "@/utils";
import { ImpersonationSwitchDialog } from "@/components/Modals";

export const GlobalAdminShortcuts: React.FC = () => {
  const { isImpersonating } = useSocialCoachSession();
  const canImpersonate = useCanImpersonate();
  const [isOpen, setIsOpen] = useState(false);

  const hasAccess = isImpersonating || canImpersonate;

  useEffect(() => {
    if (!hasAccess) return;

    const handleGlobalKeyDown = (e: KeyboardEvent) => {
      // Check for Cmd + K or Ctrl + K
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setIsOpen(prev => !prev);
      }
    };

    const handleOpenEvent = () => setIsOpen(true);

    window.addEventListener("keydown", handleGlobalKeyDown);
    window.addEventListener("open-global-impersonation-switch", handleOpenEvent);

    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
      window.removeEventListener("open-global-impersonation-switch", handleOpenEvent);
    };
  }, [hasAccess]);

  if (!hasAccess) return null;

  return <ImpersonationSwitchDialog open={isOpen} onOpenChange={setIsOpen} />;
};
